import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserRoles } from '~entities/users';
import { checkMinRoleValue } from '~shared/utils/role-guard';
import { queryClient } from '~app/query-client';

import { FormsSettingsPage } from '~features/form-settings';
import { getFormConfigsOptions } from '~features/form-submissions/api/get-form-configs';

function RouteComponent() {
  return <FormsSettingsPage />;
}

export const Route = createFileRoute('/_auth/_layout/forms')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }

    await queryClient.ensureQueryData(getFormConfigsOptions());

    return {
      maxAge: 60 * 1000,
    };
  },
  component: RouteComponent,
});
